import getViewport from './getViewport';
import Flickity from 'flickity';
import initGalleryAnimation from './galleryAnimation';

function initGallery(gallery) {
  const slides = gallery.querySelectorAll('.gallery__slide');
  const slideCount = slides.length;
  
  const odd = gallery.classList.contains('odd');
  const { width } = getViewport();
  const mobile = width < 768;

    const flkty = new Flickity(gallery, {
      cellSelector: '.gallery__slide',
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false,
      rightToLeft: odd ? false : true,
      cellAlign: mobile ? 'center' : odd ? 'left' : 'right',
      percentPosition: mobile ? false : true,
      // cellAlign: odd ? 'left' : 'right',
      // initialIndex: 1,
    });
    

    const forwardButton = gallery.querySelector('.gallery__button');
    forwardButton.addEventListener('click', e => {
      flkty.next(true);
    });

    window.addEventListener('resize', () => flkty.resize());

    initGalleryAnimation(gallery);
}

export default initGallery;